import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section className="py-20 bg-accent overflow-hidden" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-165">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="w-full lg:w-1/2" data-id="element-166">
            <div className="relative rounded-[10px] overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-square" data-id="element-167">
              <img src="https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80" alt="Professional tow truck driver" className="w-full h-full object-cover" data-id="element-168" />
              <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply" data-id="element-169"></div>
            </div>
          </motion.div>

          {/* Text Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-170">
            <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-6" data-id="element-171">
              Our Mission
            </span>
            <blockquote className="relative pl-6 border-l-4 border-primary" data-id="element-172">
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-secondary leading-tight md:leading-snug" data-id="element-173">
                "To keep our neighbors safe and moving, 24 hours a day, with
                professional care."
              </p>
            </blockquote>
            <div className="mt-8" data-id="element-174">
              <p className="text-gray-600 text-xl" data-id="element-175">
                We believe that roadside assistance shouldn't be a waiting game.
                Our zero-queue digital dispatch ensures help is routed to you
                the moment you need it.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}